import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from "element-ui/lib/locale/lang/en";
import Vuelidate from 'vuelidate';
import vueShortkey from 'vue-shortkey';
import VueTouch from 'vue-touch';
import VCalendar from 'v-calendar';
// import "v-calendar/lib/v-calendar.min.css";
import VueContentPlaceholders from 'vue-content-placeholders';
import AOS from 'aos'
import 'aos/dist/aos.css'
import OtpInput from "@bachdgvn/vue-otp-input";

import SocketPlugin from './mixins/WebSocket.js';
Vue.use(SocketPlugin);
// import './../public/index.html';

const eventBus = new Vue();
window.eventBus = eventBus;


Vue.component("v-otp-input", OtpInput);


Vue.use(VueContentPlaceholders);
Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
// Vue.use(ElementUI);
Vue.use(Vuelidate);
Vue.use(vueShortkey);
Vue.use(VueTouch);

Vue.use(VCalendar, {
  formats: {
    title: "MMMM YYYY",
    weekdays: "W",
    navMonths: "MMM",
    input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
    dayPopover: "L"
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    AOS.init()
  },
}).$mount('#app')
